<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :other-params="{
          planId:planId,deptOrUser:0
        }"
        :height="600"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
    >
    </x-grid>


  </div>
</template>

<script>
import {
  GridMixin,
  api,
  fac, loadBaseCodeData,
} from "@/utils/common/XGridBase"
import {dataApi} from "@/services/client/inherit";


//列表接口
const url = api.plan.GETDEPTCOUNT;

//主键
const rowId = 'planId';

//列
const columns = [
  fac.makeColumn("deptName", "经理部", 160),
  // fac.makeColumn("saCount", "已完成", 160),
  // fac.makeColumn("planDistributeNum", "总计", 160),
  fac.makeColumn("zhFinishCount", "载货已完成", 100),
  fac.makeColumn("qyFinishCount", "牵引已完成", 100),
  fac.makeColumn("gcFinishCount", "工程已完成", 100),
  fac.makeColumn("zyFinishCount", "专用已完成", 100),
  fac.makeColumn("qkFinishCount", "轻卡已完成", 100),
  fac.makeColumn("xnyFinishCount", "新能源已完成", 100),
  fac.makeColumn("planTime", "计划时间", 160),
  // fac.makeColumn("monthCount", "上月完成情况", 200),
  // fac.makeColumn("yearCount", "本年完成情况", 200, 'center')
  fac.makeColumn("zhYearCount", "载货本年完成情况", 150, 'center'),
  fac.makeColumn("qyYearCount", "牵引本年完成情况", 150, 'center'),
  fac.makeColumn("gcYearCount", "工程本年完成情况", 150, 'center'),
  fac.makeColumn("zyYearCount", "专用本年完成情况", 150, 'center'),
  fac.makeColumn("qkYearCount", "轻卡本年完成情况", 150, 'center'),
  fac.makeColumn("xnyYearCount", "新能源本年完成情况", 150, 'center'),

  fac.makeColumn("zhMonthCount", "载货本年完成情况", 150, 'center'),
  fac.makeColumn("qyMonthCount", "牵引本年完成情况", 150, 'center'),
  fac.makeColumn("gcMonthCount", "工程本年完成情况", 150, 'center'),
  fac.makeColumn("zyMonthCount", "专用本年完成情况", 150, 'center'),
  fac.makeColumn("qkMonthCount", "轻卡本年完成情况", 150, 'center'),
  fac.makeColumn("xnyMonthCount", "新能源本年完成情况", 150, 'center'),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {
    field: "deptId",
    title: "经理部",
    type: "select",
    options: [],
  },
])
async function loadBaseData() {
  let region = {
    isRegion: 1,
    isDealer: 0
  }
  let dealer = {
    isRegion: 0,
    isDealer: 1
  }
  this.strainOptions = await loadBaseCodeData('CD200007')
  this.wantLevelOptions = await loadBaseCodeData('CD200002')

  this.regionOptions = await dataApi.selection(region);//经理部
  this.dealerOptions = await dataApi.selection(dealer);//经销商
  // let commCodeData = await dataApi.getCommCode();
  // let DeptUsers = await dataApi.getDeptUsers();
  // if(DeptUsers.code!==200){
  // }
  // 经理部下拉处理
  this.regionOptions = this.regionOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.regionOptions = [{
    value: '',
    label: '全部'
  }].concat(this.regionOptions);
  this.loadSearchOption({
    deptId: this.regionOptions,
  })
  // 经销商下拉处理
  this.dealerOptions = this.dealerOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.dealerOptions = [{
    value: '',
    label: '全部'
  }].concat(this.dealerOptions);
  this.loadSearchOption({
    isDealerId: this.dealerOptions,
  })
  this.strainOptions = this.strainOptions.map(v => {
    return {
      label: v.label,
      value: v.label
    }
  })
  this.strainOptions = [{
    value: '',
    label: '全部'
  }].concat(this.strainOptions);
  this.loadSearchOption({
    strainName: this.strainOptions,
  })

  this.wantLevelOptions = this.wantLevelOptions.map(v => {
    return {
      label: v.label,
      value: v.label
    }
  })
  this.wantLevelOptions = [{
    value: '',
    label: '全部'
  }].concat(this.wantLevelOptions);
  this.loadSearchOption({
    wantLevelName: this.wantLevelOptions,
  })
}
//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: true,
  delData: false,
  addData: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);


export default {
  mixins: [GridMixin],
  // props: ['planId','deptOrUser','navSwitch'],
  props:{
    planId:{
      type: Number,
      default: 0
    },
    deptOrUser:{
      type:Number
    },
    navSwitch:{
      type: Number
    }
  },
  data() {
    const vm = this
    return {
      columns,
      rowId,
      url,
      // exportUrl: api.operate.MASS_SEND_WORK + '/wxMsgTaskLog/exportExcel?taskId=' + this.taskId,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      regionOptions: [],
      dealerOptions: [],
      exportUrl:api.plan.CHECK,
      exportConfig: {
        remote: true,
        beforeExportMethod({options}){
          console.log(options)
          console.log(vm)
          options.planId = vm.planId;
          options.deptOrUser = vm.deptOrUser;
          return options
        },
        exportMethod({options}) {
          return vm.exportMethod({
            options
          })
        },
        types: ['xlsx'],
        modes: ['current', 'selected', 'all']
      },
    }
  },
  watch:{
  },
  mounted() {
  },
  methods: {
    loadBaseData,
  }
}
</script>

<style scoped>
</style>